<template>
  <PageLayout :hasPadding_pageMain="false"> 
    <template #header>
      <PageHeader 
        :user-name="userDisplayName" 
        :welcome-message="$t('Webportal.LoopAi.WelcomeMsg')" 
        :showDate="false"
        :showHeroImage="false"
      />
    </template>

    <template #main>
      <div class="lai-overview-container">
        <div class="lai-overview-top">
          <ChatComposer @submit="sendMessage"></ChatComposer>
        </div>
        <div class="lai-overview-mid">
          <div class="lai-overview-col">
            <div style="width: 100%; text-align: left;">{{ $t('Webportal.LoopAi.QuickActionsTitle') }}</div>
            <template v-for="( prompt, index ) in predefinedPrompts" v-bind:key="`predefinedPrompt-${index}`">
              <BCard class="lai-overview-card" @click="sendMessage(prompt)">
                <BCardTitle>{{ prompt }}</BCardTitle>
                <BCardText>
                  <div>
                    &nbsp;
                  </div>
                </BCardText>
              </BCard>
            </template>
          </div>
          <div class="lai-overview-col">
            <div style="width: 100%; text-align: left;">{{ $t('Webportal.LoopAi.HistoryTitle') }}</div>
            <template v-for="history in histories" v-bind:key="history.sessionId">
              <BCard class="lai-overview-card" @click="selectChatSession(history.sessionId)">
                <BCardTitle>
                  {{ history.text }}
                  <button class="lai-delete-btn" @click.stop="deleteChat(history.sessionId)"><i class="fa fa-times"></i></button>
                </BCardTitle>
                <BCardText>
                  <div>
                    {{ toLocaleDateTimeString(history.lastUpdatedAt ?? history.createdAt) }}
                  </div>
                </BCardText>
              </BCard>
            </template>
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/componentsv3/PageLayout.vue';
import PageHeader from '@/componentsv3/PageHeader.vue';
import ChatComposer from './ChatComposer.vue';

import LoopAiService from '@/services/LoopAiService';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Overview',
  components: {
    PageLayout,
    PageHeader,
    ChatComposer
  },
  data() {
    return {
      histories: [],
      predefinedPrompts: null
    }
  },
  computed: {
    ...mapGetters('auth', [ 'userDisplayName' ]),
    ...mapGetters('localization', [ 'currentLocale' ]),
  },
  async mounted() {
    this.getChatHistory();
    this.getPredefinedPrompts();
  },
  methods: {
    async deleteChat(sessionId) {
      await LoopAiService.deleteChatHistory(sessionId);
      await this.getChatHistory();
    },
    async getChatHistory() {
      const { data } = await LoopAiService.getChatHistory(0, 10);
      this.histories = data.summaries;
    },
    async getPredefinedPrompts() {
      const getPredefinedPromptsResult = await LoopAiService.getPredefinedPrompts(this.currentLocale);
      this.predefinedPrompts = getPredefinedPromptsResult?.data;
    },
    sendMessage(prompt) {
      let chatSession = {
        sessionId: null,
        prompt: prompt
      };
      this.$emit("setChatSession", chatSession)
    },
    selectChatSession(sessionId) {
      let chatSession = {
        sessionId: sessionId,
        prompt: null
      };
      this.$emit("setChatSession", chatSession)
    },
    toLocaleDateTimeString(dateTime) {
      const date = new Date(dateTime);
      return date.toLocaleString();
    },
  },
  
  watch: {
    currentLocale() {
      this.getPredefinedPrompts();
    }
  },
};
</script>
